import { buildMessengerV2ConversationPath } from '../messengerV2Routes.js';

const toStringOrNull = (value) => {
  if (value == null) return null;
  const normalized = String(value).trim();
  return normalized || null;
};

const toUnreadCount = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return 0;
  return Math.max(0, Math.trunc(parsed));
};

const isRoomConversation = (conversation = {}) =>
  String(conversation?.kind ?? conversation?.meta?.kind ?? '').trim().toLowerCase() === 'room' ||
  conversation?.room_id != null ||
  conversation?.roomId != null ||
  conversation?.room?.id != null ||
  conversation?.room_channel != null ||
  conversation?.roomChannel != null;

const selectUnreadConversations = (state = {}) => {
  const unreadByConversation = new Map();

  (Array.isArray(state?.conversations) ? state.conversations : []).forEach((conversation) => {
    // Room chat has its own surface and notification lifecycle. Realtime Room
    // metadata may still be reconciled into the shared controller, but it must
    // never contribute to the standalone Messenger badge or destination.
    if (isRoomConversation(conversation)) return;

    const conversationId = toStringOrNull(conversation?.id ?? null);
    if (!conversationId) return;

    const unreadCount = toUnreadCount(conversation?.unread_count ?? conversation?.unreadCount ?? 0);
    const existing = unreadByConversation.get(conversationId);
    unreadByConversation.set(conversationId, {
      conversation: existing ? { ...existing.conversation, ...conversation } : conversation,
      conversationId,
      unreadCount: Math.max(existing?.unreadCount ?? 0, unreadCount),
    });
  });

  return Array.from(unreadByConversation.values()).filter(({ unreadCount }) => unreadCount > 0);
};

export const selectMessengerV2UnreadCount = (state = {}) =>
  selectUnreadConversations(state).reduce((total, { unreadCount }) => total + unreadCount, 0);

export const selectMessengerV2UnreadDestination = (state = {}) => {
  const unreadConversations = selectUnreadConversations(state);
  if (unreadConversations.length !== 1) return '/messages';

  const [{ conversation, conversationId }] = unreadConversations;
  return buildMessengerV2ConversationPath(conversationId, conversation);
};
